import React from 'react';
import PropTypes from 'prop-types';
import { get, orderBy } from 'lodash';
import { css } from '@bd/bdui-styles/emotion';
import CoreMap from '@bd/bdui-coremap';
import withData from '@bd/bdcore-data';
import { Link } from '@bd/bdcore-named-routes';
import HomeCard from '../../components/HomeCard';
import { colors } from '../../styles';

const styles = css`
  padding: 30px 0;
  @media (min-width: 992px) {
      padding: 90px 0;
  }
`;


const homeMap = css`
  position: relative;
  height: 300px;
  width: 100%;
  z-index: 0;

  @media (min-width: 992px) {
    width: auto;
    flex-grow: 1;
    height: calc(100vh - 115px);
  }

  background-color: ${colors.color3};
  .leaflet-container {
    width: 100%;
    height: 100%;
  }
  .leaflet-popup-content-wrapper {
    .HomeCard_wrapper {
      width: 100% !important;
    }
    .HomeCard_inner {
      flex-direction: column !important;
    }
    .HomeCard_mapButton {
      display: none !important;
    }
    .HomeCard_detailButton {
      width: 100% !important;
    }
    .HomeCard_buttonWrapper {
      margin: 0 !important;
    }
    .HomeCard_priceValue {
      padding: 10px 8px !important;
    }
  }
`;

function HomesResults({ homes, sort, showMap }) {
  const modelHomes = homes.filter(home => home.isModel === true);
  return (
    <div className={styles}>
      {
        modelHomes.length > 0 &&
        <div>
          {
            showMap &&
            <CoreMap
              animate
              useFlyTo
              boundsOptions={{ animate: true, duration: 0.5 }}
              pin={{
                iconUrl: '/images/icon-map-pin-site.svg',
              }}
              className={homeMap}
              markers={homes}
              popup={({ marker: home }) => (
                <HomeCard home={home} />
              )}
            />
          }
          {
            !showMap &&
            <div className="container">
              <div className="row pb-5 justify-content-center">
                {
                  orderBy(modelHomes, sort.field, get(sort, 'dir', 'asc')).map(home => (
                    <div key={home._id} className="col-md-6 col-xl-4">
                      <HomeCard home={home} />
                    </div>
                  ))
                }
              </div>
            </div>
          }
        </div>
      }
      {
        modelHomes.length === 0 &&
        <div className="container">
          <div className="row">
            <div className="col-lg-6 mx-auto py-5 text-center">
              There are no model homes available at this time. Please check
              back soon for updates. In the meantime, please view our <Link name="plans">available floor plans</Link>.
            </div>
          </div>
        </div>
      }
    </div>
  );
}

HomesResults.propTypes = {
  homes: PropTypes.arrayOf(PropTypes.object).isRequired,
  sort: PropTypes.object.isRequired,
  showMap: PropTypes.bool.isRequired,
};

export default withData(
  {
    homes: true,
  },
)(HomesResults);



// WEBPACK FOOTER //
// ./src/pages/ModelHomes/HomesResults.js